import useUtils from '@/micro/composables/useUtils'
import { useRootStore } from '@/micro/store/root'
import { useRegisterStore } from '@/micro/store/register'
import { originDictionary } from '@/micro/utils/origin'
import { OriginKeyword, OnboardingType } from '@/micro/types/register.type'
import { ORIGIN_PATTERNS } from '@/micro/modules/origin'

export default function () {
  const rootStore = useRootStore()
  const registerStore = useRegisterStore()
  const { getUserReferrer } = useUtils()
  const referrer = getUserReferrer()

  const getOriginKeyword = (): OriginKeyword => {
    // Barremos el diccionario de orígenes y evaluamos
    // las reglas para encontrar una coincidencia
    for (const [origin, rules] of Object.entries(originDictionary)) {
      const result = rules(referrer, rootStore.country)
      if (result) {
        return origin as OriginKeyword
      }
    }

    // Si no se encuentra ninguna coincidencia, asignamos 'alegra-api' por defecto
    return 'alegra-api'
  }

  const getOnboardingType = (): OnboardingType => {
    const originKeyword = registerStore.originKeyword
    let onboardingType: OnboardingType = 'generic'

    // OnboardingType con relación al OrigenKeyword
    const origins: Partial<Record<OriginKeyword, OnboardingType>> = {
      'alegra-resico': 'resico',
      educacion: 'education',
      'alegra-only-invoicing': 'onlyInvoicing',
    }

    // Patrones de origen para determinar el onboardingType
    // No tienen relacion con el OrigenKeyword
    const patterns: Record<string, { pattern: RegExp; value: OnboardingType }> = {
      ALEGRA_CONTADORES: {
        pattern: ORIGIN_PATTERNS.ALEGRA_CONTADORES,
        value: 'accountant',
      },
      ALEGRA_CONTADOR: {
        pattern: ORIGIN_PATTERNS.ALEGRA_CONTADOR,
        value: 'accountant',
      },
      ALEGRA_MIGRATION: {
        pattern: ORIGIN_PATTERNS.ALEGRA_MIGRATION,
        value: 'migration',
      },
      SECTOR_SALUD: {
        pattern: ORIGIN_PATTERNS.SECTOR_SALUD,
        value: 'health',
      },
    }

    // Si el onboardingType está definido en el diccionario de orígenes, lo retornamos
    if (origins[originKeyword]) {
      onboardingType = origins[originKeyword]
      return onboardingType
    }

    // Recorremos los patrones y evaluamos si hay coincidencia con el referrer
    for (const { pattern, value } of Object.values(patterns)) {
      if (pattern.test(referrer)) {
        onboardingType = value as OnboardingType
        return onboardingType
      }
    }

    return onboardingType
  }

  return {
    getOriginKeyword,
    getOnboardingType,
  }
}
